import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ConsultarService {
    constructor(private readonly http: HttpClient) {}

    private readonly apiSiriUrl = environment.apiSiriUrl;

    /**
     * Obtiene todos los registros de productos comercializadores con paginación
     * Permite filtrar por agente vigilado
     * @param page - Página actual
     * @param limit - Límite de registros por página
     * @param agenteVigiladoId - ID del agente vigilado para filtrar (opcional)
     * @param filtros - Objeto de filtros (opcional)
     * @returns Promise con array de registros
     */
    async getProductosComercializador(
        page: string,
        limit: string,
        agenteVigiladoId?: string,
        filtros?: any
    ): Promise<any> {
        try {
            const url = `${this.apiSiriUrl}registros-comercializador`;

            // Construir parámetros de consulta
            let params = new HttpParams().set('page', page).set('limit', limit);

            if (agenteVigiladoId) {
                params = params.set('agenteVigiladoId', agenteVigiladoId);
            }

            //  Enviar los filtros como parámetros planos
            if (filtros) {
                for (const key of Object.keys(filtros)) {
                    const value = filtros[key];
                    if (value !== undefined && value !== null && value !== '') {
                        params = params.set(key, value);
                    }
                }
            }

            return await firstValueFrom(this.http.get<any>(url, { params }));
        } catch (error) {
            console.error('Error en getProductosComercializador:', error);
            throw error;
        }
    }

    /**
     * Actualiza el estado de un registro de producto comercializador
     * @param registroId - ID del registro a actualizar
     * @param nuevoEstado - Nuevo estado a asignar
     * @returns Promise con la respuesta de la actualización
     */
    async actualizarEstado(
        registroId: string,
        nuevoEstado: string
    ): Promise<any> {
        try {
            const url = `${this.apiSiriUrl}registros-comercializador/${registroId}/${nuevoEstado}`;
            return await firstValueFrom(this.http.put<any>(url, {}));
        } catch (error) {
            console.error('Error en actualizarEstado:', error);
            throw error;
        }
    }
}
